var evolutionHandler = () => {
    const intentusChartEl = document.getElementById('intentusChart');
    if (!intentusChartEl) {
        return;
    }

    const ctx = intentusChartEl.getContext('2d');

    const chartData = JSON.parse(document.getElementById('chartData').textContent);

    const data = {
        labels: chartData.labels,
        datasets: [
            {
                label: chartData.completed_tasks_label,
                data: chartData.completed_tasks,
                borderColor: 'rgba(75, 192, 192, 1)',
                tension: 0.4,
                fill: false,
            },
            {
                label: chartData.total_time_spent_label,
                data: chartData.total_time_spent,
                borderColor: 'rgba(54, 162, 235, 1)',
                tension: 0.4,
                fill: false,
            },
            {
                label: chartData.uncompleted_tasks_label,
                data: chartData.uncompleted_tasks,
                borderColor: 'rgba(255, 99, 132, 1)',
                tension: 0.4,
                fill: false,
            },

        ],
    };

    const config = {
        type: 'line',
        data: data,
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: true,
                },
                tooltip: {
                    mode: 'index',
                    intersect: false,
                },
            },
            scales: {
                x: {
                    title: {
                        display: true,
                        text: chartData.scale_x_label,
                    },
                },
                y: {
                    title: {
                        display: true,
                        text: chartData.scale_y_label,
                    },
                },
            },
        },
    };

    const intentusChart = new Chart(ctx, config);

}